import axios from "axios";

export const getProductsFromExternalApi = async (token: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/products/list`,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return response.data;
};

export const updateProduct = async (
  token: string,
  name: string,
  data: object
) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_API_BASE_URL}/cms/products`,
    data,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: { productName: name },
    }
  );
  return response.data;
};

export const getProduct = async (name: string) => {
  const response = await axios.get(
    `${process.env.REACT_APP_API_BASE_URL}/cms/products`,
    { params: { productName: name } }
  );
  return response.data;
};
